import styled from 'styled-components'

const Error = styled.div`
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  color: red;
}
`

const ErrorMessage = styled.div`
  color: black;
  font-size: 44px;
  margin-left: 10px;
`

export default {
  Error,
  ErrorMessage,
}
